import { postUrl } from '@/apiCalls/fetch';

export interface ISubscribeTicket {
    /** The short-lived JWT the relay verifies. Worth ~60 seconds if it leaks. */
    ticket: string;
    /** The borrower id, from the verified session. Routing segment only. */
    subject: string;
}

interface IMintSubscribeTicketResponse {
    status: string;
    data: ISubscribeTicket;
}

/**
 * Ask Apply's API for a subscribe ticket for the SSE relay.
 *
 * Goes through the shared axios client, so it carries the session token and
 * inherits the 401 interceptor — a mint that fails because the session has
 * lapsed logs the borrower out, which is the correct outcome and the same one
 * every other authenticated call produces.
 *
 * Throws on any failure. The caller must NOT fall back to opening the stream
 * without a ticket: the whole point of the ticket is that the relay stops
 * believing an identity asserted in the URL.
 */
export async function mintSubscribeTicket(): Promise<ISubscribeTicket> {
    const response = await postUrl<IMintSubscribeTicketResponse>(
        '/api/sse/ticket',
        {}
    );

    const ticket = response?.data?.ticket;
    const subject = response?.data?.subject;

    if (!ticket || !subject) {
        throw new Error('subscribe ticket missing from response');
    }

    return { ticket, subject };
}
